import { useTranslation } from 'react-i18next';
import { cx } from '@platform/core/lib/cx';
import { Icon } from '@platform/ui';
import type { IRestrictedValueProps } from './IRestrictedValueProps';

/**
 * Значення поля з персональними даними, яке сервер приховав від користувача (07-Security §2.3: бачать власник і адміністратор простору,
 * автор і виконавець запису): без значення й без контрола редагування — замок і «Приховано» приглушено (UIUX foundations/states:
 * лише читання — без рамки, текст; не порожнє місце), хто бачить значення — у підказці. У формі — поле сірого тла висотою контрола, у
 * клітинці й на картці — лише замок і слово, у ключовому рядку — з міткою поля.
 */
export function RestrictedValue({ id, prefix, compact }: IRestrictedValueProps) {
  const { t } = useTranslation();
  const hint = t('fieldControls.restrictedHint');
  return (
    <span id={id} className={cx('fc-restricted', compact && 'fc-restricted--compact', prefix !== undefined && 'fc-restricted--key')} title={hint} data-restricted="">
      {prefix && <span className="fc-restricted__prefix">{prefix}</span>}
      <Icon name="lock" size={12} strokeWidth={2} className="fc-restricted__icon" />
      <span className="fc-restricted__text">{t('fieldControls.restricted')}</span>
    </span>
  );
}
